import { combineReducers } from 'redux';
import { DEFAULT_REDUCERS } from '@nsd/fe';
import { reducer as formReducer } from 'redux-form';
import dispatchStatusReducer from './dispatchStatusReducer';
import dispatchWorkflowReducer from './dispatchWorkflowReducer';
import driversReducer from './driversReducer';
import typesReducer from './typesReducer';
import providersReducer from './providerReducer';
import dispatchServicesReducer from './dispatchServicesReducer';
import settingsReducer from './settingsReducer';
import digitalDispatchTimerReducer from './digitalDispatchTimer';
import digitalDispatchPostApprovalEventNotificationReducer from './digitalDispatchPostApprovalEventNotifications';
import callCenterReducer from './callCenterReducer';
import clientsReducer from './clientsReducer';
import allDispatchWorkflowsReducer from './allDispatchWorkflowsReducer';
import dispatchStatusAndStateMappingReducer from './dispatchStatusAndStateMappingReducer';
import preferredLocationListReducer from './preferredLocationListsReducer';
import five9Reducer from './five9Reducer';

// Developer adds their own reducers after spreading
// in the DEFAULT_REDUCERS to not overwrite any needed keys
const rootReducer = combineReducers({
  ...DEFAULT_REDUCERS,
  providers: providersReducer,
  form: formReducer,
  dispatchStatus: dispatchStatusReducer,
  dispatchWorkflow: dispatchWorkflowReducer,
  drivers: driversReducer,
  types: typesReducer,
  dispatchServices: dispatchServicesReducer,
  settings: settingsReducer,
  digitalDispatchTimer: digitalDispatchTimerReducer,
  digitalDispatchPostApprovalEventNotifications: digitalDispatchPostApprovalEventNotificationReducer,
  callCenters: callCenterReducer,
  clients: clientsReducer,
  allDispatchWorkflows: allDispatchWorkflowsReducer,
  dispatchStatusAndStateMapping: dispatchStatusAndStateMappingReducer,
  preferredLocationLists: preferredLocationListReducer,
  five9: five9Reducer
});

export default rootReducer;
